import './node-jvm-stats-table.style.scss'

class nodeJvmStatsTableController {

}

export default nodeJvmStatsTableController;



// WEBPACK FOOTER //
// ./ui/src/components/node-jvm-stats-table/node-jvm-stats-table.controller.js